module.exports = __webpack_public_path__ + "static/media/optima-seguros-vial.376f16b7.svg";